import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import Icon from '../../../@shared/icon';

export type TAccordionItemProps = {
  index?: string;
  header?: string;
  isCollapsed?: boolean;
  onclick?: () => void;
  children: React.ReactNode;
  istoggleIndependent?: string;
};

const AccordionItem: FC<TAccordionItemProps> = ({ header, isCollapsed, onclick, istoggleIndependent, children }) => {
  const [isToggleIndex, setBindIndex] = React.useState(isCollapsed);
  const isTabCollapsed = istoggleIndependent !== 'true' ? isCollapsed : isToggleIndex;
  const iconName = isTabCollapsed ? 'action-plus' : 'action-minus';
  const toggleCls = isTabCollapsed ? 'collapsed' : 'expanded';

  const clickHandler = (): void => {
    if (istoggleIndependent !== 'true') {
      onclick && onclick();
    } else {
      setBindIndex(!isToggleIndex);
    }
  };

  return (
    <div className="accordion-item__card">
      <button className="accordion-item__card-header" onClick={clickHandler}>
        <Icon iconName={iconName} size={iconSize.mbl} color="primary" extraClassName="accordion-item__card-icon" />
        {header && <RichText tag="div" field={{ value: header }} className="accordion-item__card-title rich-text" />}
      </button>
      <div className={`accordion-item__card-body ${toggleCls}`}>{children}</div>
    </div>
  );
};

export default AccordionItem;
